export const stats = [
  { value: '12', label: 'Tomes Numériques Complets' },
  { value: '+2.000', label: 'Enseignants Satisfaits' },
  { value: '4.500+', label: 'Heures de Préparation Gagnées' },
  { value: '99%', label: 'Le Recommandent' },
]

export const differenceStats = [
  { value: '12', label: 'Volumes PDF (CP à Terminale)' },
  { value: '2', label: 'Lignes : Primaire & Secondaire' },
  { value: '100%', label: 'Téléchargement Immédiat' },
]

export const beforeItems = [
  'Des heures passées à planifier chaque leçon de zéro',
  'Des exercices répétitifs, ennuyeux et flous',
  'Stress constant du dimanche soir à chercher des fiches',
  'Élèves démotivés qui « détestent l’anglais »',
]

export const afterItems = [
  '5 minutes de révision et vous êtes prêt pour la classe',
  'Des projets linguistiques visuels et stimulants',
  'Un système complet pour préparer moins et enseigner plus',
  'Des élèves qui parlent avec une confiance absolue',
]

export const recognizeItems = [
  {
    emoji: '😰',
    text: 'Arriver en classe sans savoir comment expliquer une notion complexe de grammaire.',
  },
  {
    emoji: '⏱️',
    text: 'Passer tout le week-end à préparer ce qui devrait vous prendre quelques minutes.',
  },
  {
    emoji: '🤷',
    text: 'Chercher sans fin des fiches pédagogiques vraiment visuelles, de qualité et prêtes à imprimer.',
  },
  {
    emoji: '😴',
    text: "Des élèves qui décrochent parce que le matériel n'est pas adapté à leur niveau réel.",
  },
]

export const primaryVolumes = [
  {
    tome: 'Tome 1',
    level: 'CP',
    title: "Découvrir l'anglais",
    text: 'Listening, rituels, flashcards et oral guidé',
  },
  {
    tome: 'Tome 2',
    level: 'CE1',
    title: 'Premiers mots et phrases',
    text: 'Construire les premières phrases en contexte',
  },
  {
    tome: 'Tome 3',
    level: 'CE2',
    title: 'Communiquer en anglais',
    text: 'Présent simple, structures et questions',
  },
  {
    tome: 'Tome 4',
    level: 'CM1',
    title: 'Développer son anglais',
    text: 'Développement des 4 compétences',
  },
  {
    tome: 'Tome 5',
    level: 'CM2',
    title: 'Prêt pour le collège',
    text: 'Clôture de la primaire et transition fluide',
  },
]

export const secondaryVolumes = [
  {
    tome: 'Tome 1',
    level: '6e',
    title: 'Fondations',
    text: 'A1 Mastery',
  },
  {
    tome: 'Tome 2',
    level: '5e',
    title: 'Communication',
    text: 'A1 → A2 Progrès',
  },
  {
    tome: 'Tome 3',
    level: '4e',
    title: 'Développement',
    text: 'A2 Consolidation',
  },
  {
    tome: 'Tome 4',
    level: '3e',
    title: 'Consolidation',
    text: 'A2 → B1 Objectif Lycée',
  },
  {
    tome: 'Tome 5',
    level: 'Seconde',
    title: 'Autonomie',
    text: 'B1 Gagner en autonomie',
  },
  {
    tome: 'Tome 6',
    level: 'Première',
    title: 'Approfondissement',
    text: 'B1 → B2 Argumenter',
  },
  {
    tome: 'Tome 7',
    level: 'Terminale',
    title: 'Maîtrise',
    text: 'B2 Réussite aux examens — 100% en anglais',
  },
]

export const pageSamples = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/8q8tkLRhGQ4GHb2ZThtvCG/Captura_de_pantalla_2026-09-13_a_las_5.10.01_p_(1).webp',
    level: 'CP · Fiche Élève',
    title: 'Colour Match',
    caption:
      'Fiche à colorier prête à imprimer : les élèves associent chaque objet à sa couleur en anglais.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/g1SrX5pAWDxdmnx5gFzQuC/Captura_de_pantalla_2026-09-13_a_las_5.24.05_p.webp',
    level: 'CE1 · Exercices',
    title: 'Student Worksheet 4',
    caption:
      'Tracé des nombres, mini-défi de calcul en anglais et structure « I am ___ years old ».',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/mUDPafqCRA2vUuCPnJwUGu/Captura_de_pantalla_2026-09-13_a_las_5.25.18_p.webp',
    level: 'CE2 · Activité',
    title: 'Routine Match Activity',
    caption:
      'Activité de reliage image-phrase pour ancrer le vocabulaire de la routine quotidienne.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/tVH4wsA3Ji4Qttu9DizSgR/Captura_de_pantalla_2026-09-13_a_las_5.26.00_p_(1).webp',
    level: '6e · Vocabulaire',
    title: 'Personality Adjectives',
    caption:
      'Planche de vocabulaire illustrée en haute définition, prête à projeter ou à afficher en classe.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/rL5rL4eHpDaKQACX8pSRt8/Captura_de_pantalla_2026-09-13_a_las_5.26.52_p.webp',
    level: '4e · Grammaire',
    title: 'Grammar Spotlight : The Past Simple',
    caption:
      'Fiche de grammaire visuelle : verbes réguliers et irréguliers expliqués en un seul coup d’œil.',
  },
]

export const bonuses = [
  {
    title: "Rituels d'Anglais Quotidiens CP–CM2",
    was: '17 USD',
    text: "Des routines simples et rapides pour faire 5 à 10 minutes d'anglais chaque jour sans aucune préparation.",
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/f72acbec-6480-43bf-9f0e-44b632e6a0d8.jpg',
  },
  {
    title: 'Scripts de Prononciation pour le Professeur',
    was: '17 USD',
    text: 'Des phrases prêtes à lire et à utiliser en classe pour parler anglais avec assurance devant vos élèves.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/b8ae0ee0-9540-42c8-bcbc-80e42d9dfb00.jpg',
  },
  {
    title: "Planification Annuelle Prête à l'Emploi",
    was: '17 USD',
    text: 'Une progression claire, semaine par semaine, pour organiser toute votre année sans stress.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/e45284b2-8ab2-4529-9606-1d9c1e34dfb7.jpg',
  },
  {
    title: "Kit d'Évaluations et Rubriques CP–CM2",
    was: '17 USD',
    text: 'Des évaluations simples, des grilles de notation et des checklists prêtes à imprimer pour suivre chaque progrès.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/e2568952-6f2f-4f78-a701-c53fefbd8999.jpg',
  },
  {
    title: "Mini-Projets d'Anglais Fin de Période",
    was: '17 USD',
    text: 'Des projets courts, ludiques et motivants pour valider les acquis à la fin de chaque période scolaire.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/f3473318-6a41-4426-a231-bf7d9838b178.jpg',
  },
]

export const offerRows = [
  {
    label: 'La Collection Complète ANGLAIS PRÊT™ (12 Volumes PDF)',
    value: '212 USD',
  },
  { label: 'Les 5 Bonus Officiels Stratégiques', value: '85 USD' },
]

export const testimonials = [
  {
    quote:
      "J'ai enfin récupéré mes dimanches. La progression complète de la primaire au lycée est une pépite absolue.",
    name: 'Claire M.',
    location: 'Lyon 🇫🇷',
  },
  {
    quote:
      "Les fiches de grammaire visuelle font une énorme différence. Même mes élèves les plus en difficulté s'impliquent.",
    name: 'Marc L.',
    location: 'Paris 🇫🇷',
  },
  {
    quote:
      "Ouvrir, imprimer, enseigner. C'est exactement la ressource professionnelle et organisée qu'il me manquait.",
    name: 'Élodie V.',
    location: 'Bordeaux 🇫🇷',
  },
]

export const faqs = [
  {
    q: 'Comment recevoir le matériel ?',
    a: 'Vous recevez un lien de téléchargement immédiat par e-mail juste après votre paiement.',
  },
  {
    q: 'Quels niveaux sont couverts ?',
    a: 'Le pack couvre tout le parcours, du CP (Primaire) jusqu’à la Terminale (Lycée).',
  },
  {
    q: 'Y a-t-il des frais mensuels ?',
    a: "Aucun. C'est un paiement unique de 27 USD pour un accès à vie.",
  },
]
